import React from "react";

export const Line = ({ className, ...restProps }) => {
  return <div className={className} {...restProps} />;
};
